/**
 * teams.js — Tournament-driven team data router.
 *
 * Re-exports from the active tournament's team file based on CURRENT_TOURNAMENT.id.
 * All consumers import from here and get the right team data automatically.
 */

import { CURRENT_TOURNAMENT } from "../config/tournament";

// Static imports — bundler tree-shakes the unused one
import * as iplTeams from "./ipl-teams";
import * as t20wcTeams from "./t20wc-teams";

const teams = CURRENT_TOURNAMENT.id.startsWith("ipl_") ? iplTeams : t20wcTeams;

export const TEAM_CODE_TO_ID = teams.TEAM_CODE_TO_ID;
export const TEAM_ID_TO_CODE = teams.TEAM_ID_TO_CODE;
export const TEAM_NAMES = teams.TEAM_NAMES;
export const TEAM_COLORS = teams.TEAM_COLORS;
export const buildTeamObject = teams.buildTeamObject;
